import React from "react";
import "./VisionMission.css";

export default function VisionMission() {
  return (
    <section className="vm-section">
      <div className="vm-container">

        {/* Vision Card */}
        <div className="vm-card">
          <h2 className="vm-title">Our Vision</h2>
          <p className="vm-text">
 To deliver transparent, customized, and affordable insurance solutions, empowering our clients to face life’s uncertainties with confidence.
          </p>
          <img
            src="/icons/glasses.png"
            alt="Vision"
            className="vm-image"
          />
        </div>

        {/* Mission Card */}
        <div className="vm-card">
          <h2 className="vm-title">Our Mission</h2>
          <p className="vm-text">
         To be recognised as a leading insurance company — known for professionalism, trustworthiness, and meaningful relationships — helping our clients build secure futures.  </p>
          <img
            src="/icons/target.png"
            alt="Mission"
            className="vm-image"
          />
        </div>

      </div>
    </section>
  );
}
